const flagWrap = (() => {

    const initBlock = (el) => {
        handleRadioToggle(el);
    };

    const handleRadioToggle = el => {
        el.querySelectorAll('.flag-wrap__flag').forEach(flag => {
            flag.addEventListener('input', () => {
                el.querySelectorAll('.flag-wrap__flag').forEach(flagItem => {
                    flagItem.classList.remove('flag-wrap__flag--checked')
                });
                flag.classList.add('flag-wrap__flag--checked');
            });
        });
    }

    return {initBlock};

})();

ControlBinders.register(`.flag-wrap`, el => flagWrap.initBlock(el));